import { tv } from '@otomoro/helpers/mergeClasses'
import { VariantProps } from 'tailwind-variants'

export const styles = tv({
	slots: {
		tableClass:
			'col-span-4 flex flex-col gap-y-2 lg:gap-y-0 lg:col-span-6 lg:grid grid-cols-4 gap-x-2 mt-2 lg:grid-cols-6 lg:gap-x-4 lg:mt-4 mx-2 md:mx-4',
		topRow: 'hidden lg:grid col-span-6 grid-cols-6 gap-x-4 py-2 border-t border-black',
	},
})

export type InformationRowsVariants = VariantProps<typeof styles>
